import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Row, Select, Skeleton, Table } from "antd";
import "./index.css";
import PropTypes from "prop-types";
import { DownloadOutlined, PrinterFilled } from "@ant-design/icons";
import { BiCalendar } from "react-icons/bi";
import { itemHeadersColumns } from "./data";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { loadPartyWiseReport } from "../../store/items/actions";
import moment from "moment";

const ItemWiseReport = (props) => {
  const itemListId = {
    organizationId: props.organizationId,
    itemId: props.itemId,
  };

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectDays, setSelectDays] = useState([]);
  // const [downloadLoading, setDownloadLoading] = useState(false);

  //api loader
  useEffect(() => {
    dispatch(loadPartyWiseReport(itemListId));
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { party_list = [] } = useSelector((state) => state.Items);

  const tableData =
    party_list && party_list.length > 0
      ? party_list.map((data, index) => {
          return {
            index: index + 1,
            quantity: data.purchaseQuantity ? data.purchaseQuantity : "--",
            salesQuantity: data.salesQuantity ? data.salesQuantity : "--",
            amount: data.purchaseAmount ? data.purchaseAmount : "--",
            salesAmount: data.salesAmount ? data.salesAmount : "--",
            closingStock: data.closingStock,
            date: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "-",
            itemId: data.itemId,
            organizationId: data.organizationId,
            serialIds: data.serialIds,
            // type: data.type,
            vendorName: data.vendorName ? data.vendorName : data.partyName,
            invoiceNumber: data.invoiceNumber ? data.invoiceNumber : "--",
            transactionType: data.type,
            updatedAt: data.updatedAt
              ? moment(data.updatedAt).format("DD-MM-YYYY")
              : "-",
            _id: data._id,
          };
        })
      : [];

  //Download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = () => {
    // setDownloadLoading(true);

    const tableExportData =
      party_list && party_list.length > 0
        ? party_list.map((data, index) => {
            return {
              index: index + 1,
              quantity: data.Quantity,
              closingStock: data.closingStock,
              date: data.createdAt
                ? moment(data.createdAt).format("DD-MM-YYYY")
                : "-",
              itemId: data.itemId,
              organizationId: data.organizationId,
              serialIds: data.serialIds,
              invoiceNumber: data.invoiceNumber ? data.invoiceNumber : "--",
              transactionType: data.transactionType,
              updatedAt: data.updatedAt
                ? moment(data.updatedAt).format("DD-MM-YYYY")
                : "-",
              _id: data._id,
            };
          })
        : [];
    setTimeout(() => {
      let headerData = [
        "Date, Transaction Type, Quantity, Invoice Number, Closing Stock",
      ];

      let usersCsv = !isEmpty(tableExportData)
        ? tableExportData.reduce((acc, user) => {
            const {
              date,
              transactionType,
              quantity,
              invoiceNumber,
              closingStock,
            } = user;
            acc.push([
              date,
              transactionType,
              quantity,
              invoiceNumber,
              closingStock,
            ]);

            console.log("test", acc);
            return acc;
          }, [])
        : false;
      console.log(usersCsv, "usersCsv");

      const usersList =
        !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

      downloadFile({
        data: [...headerData, ...usersList].join("\n"),
        fileName: "ItemStockDetails.csv",
        fileType: "text/csv",
      });
      // setDownloadLoading(false);
    }, 2500);
  };

  console.log(party_list, "party_list");

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Items | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <Row>
            <Col span={6} className="mr-3">
              {loading ? (
                <Skeleton.Input className="w-[100%]"></Skeleton.Input>
              ) : (
                <Select
                  suffixIcon={<BiCalendar size={16} />}
                  placeholder="Select Days"
                  value={selectDays}
                  onChange={(e) => setSelectDays(e)}
                  className="h-[40px] w-[100%]"
                />
              )}
            </Col>

            <Col span={4} className="pr-3 cursor-pointer">
              {loading ? (
                <Skeleton.Input className="w-[100%]"></Skeleton.Input>
              ) : (
                <div
                  onClick={() => exportToCsv()}
                  className="flex border p-2 rounded-md border-1 text-center"
                >
                  <DownloadOutlined className="text-[16px] mr-3" /> Download
                </div>
              )}
            </Col>
            <Col span={4} className="pr-3 cursor-pointer">
              {loading ? (
                <Skeleton.Input className="w-[100%]"></Skeleton.Input>
              ) : (
                <div className="flex border p-2 rounded-md  border-1 text-center">
                  <PrinterFilled className="text-[16px] mr-3" /> Print
                </div>
              )}
            </Col>
          </Row>
        </Col>
        <Col span={24} className="mt-4 mb-6">
          <div>
            <Table
              style={{
                overflow: "hidden",
                cursor: "pointer",
              }}
              bordered
              columns={itemHeadersColumns}
              dataSource={tableData}
              sortDirections={"ascend"}
              loading={loading ? true : false}
              showSorterTooltip={"sorter-icon"}
              // onRow={partiesRoutes}
              // rowHoverable={partiesRoutes}
              // sticky=""

              // rowSelection={{
              //   type: selectionType,
              //   ...rowSelection,
              // }}
              // rowSelection={true}
              // rowSelection={partiesRoutes}
              scroll={{ y: 200 }}
            />
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

ItemWiseReport.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
};

export default ItemWiseReport;
